export const THREE_MONTHS = '3 Months'
export const SIX_MONTHS = '6 Months'
export const ONE_YEAR = '1 Year'
export const TWO_YEARS = '2 Years'
export const FIVE_YEARS = '5 Years'
export const MAX = 'MAX'

